import { authAxios } from '@/common/axios';

export default {
  search: function (request) {
    return authAxios.get('/api/department/search', { params: request });
  },
  find: function (id) {
    return authAxios.get(`/api/department/${id}`);
  },
  getDepartmentsAsSelectionList: function () {
    return authAxios.get('/api/department/getdepartmentsasselectionlist');
  },
};
